<script>
  import { onMount } from 'svelte';
  import { carregaBanner, editaBanner, deletaBanner, procuraProdutos } from '../../actions/database.js';
  import { upload } from '../../actions/upload.js';
  import Page from "../../containers/Page/Page.svelte";
  import Modal from "../../components/Modal/Modal.svelte";

  export let params = {}

  let banner = {
    produtos: []
  };
  let alert;
  let error;
  let files;
  let uploading;
  let searchResult = [];

  onMount(async () => {
    banner = await carregaBanner(params.id);
  });

  const handleEdit = async () => {
    alert = "Atualizando...";
    try {
      await editaBanner(banner);
      alert = "Banner atualizado!";
    } catch (error) {
      alert = `Erro ao atualizar o banner: ${error}`;
    }
  }

  const handleUpload = async () => {
    error = null;
    if (files[0].size > 50000000) { // 50MB
      error = 'Tamanho máximo permitido é de 50MB.';
      return;
    }
    uploading = true;
    banner.image = await upload(files[0]);
    uploading = false;
  }

  const handleDelete = async () => {
    const ask = confirm(
      `Você tem certeza que quer deletar o banner?`
    );

    if (!ask) return false;

    alert = "Deletando...";
    try {
      await deletaBanner(banner);
      alert = "Banner deletada!";
    } catch (error) {
      alert = `Erro ao atualizar o banner: ${error}`;
    }
  }

  const close = () => alert = null;
</script>

{#if alert}
  <Modal
    { alert }
    { close }
  />
{/if}

{#if banner}
  <Page title="Editar Promoção">
    <div class="box">
      <div class="field is-horizontal">
        <div class="content">
          <h3>Dados da promoção:</h3>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Título</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:value={banner.titulo} class="input" type="text">
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Ativo</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <div class="select">
                <select bind:value={banner.ativo}>
                  <option value="nao">Não</option>
                  <option value="sim">Sim</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Link</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input bind:value={banner.link} class="input" type="text">
            </div>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Imagem</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:files on:change={handleUpload} class="input" type="file" accept="image/*">
            </p>
            <br>
            {#if error}
                <div class="error notification is-danger is-small">
                { error }
                </div>
            {/if}
            {#if uploading}
              <p class="control is-expanded">
                Fazendo upload 
                <progress class="progress is-small is-primary"></progress>
              </p>
            {/if}
            {#if banner.image}
              <div>
                <img width="400" src={banner.image} alt=""/>
              </div>
              <button on:click={() => banner.image = null}>
                Remover imagem
              </button>
            {/if}
          </div>
        </div>
      </div>
      <br><br>
      <div class="control has-text-right">
        <button
          on:click={handleDelete}
          class="button is-danger"
        >
          Deletar banner
        </button>
        <button
          on:click={handleEdit}
          class="button is-primary"
        >
          Editar banner
        </button>
      </div>
    </div>
  </Page>
{/if}

<style>
  .error.notification {
    padding: 10px;
  }
  .result-name {
    line-height: 39px;
  }
  .list-itens {
    padding: 10px;
  }
  .link {
    color: #3273dc;
    text-decoration: underline;
    cursor: pointer;
  }
</style>